<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <Loader v-if="loading"></Loader>
        <div class="d-flex justify-content-center align-items-center vh-100" v-else>
          <div class="user-cta">
            <Icon name="grLogin" width="36" class="mb-3"/>
            <div class="mb-5">
              <h4 class="user-cta__title">{{ $t('sso.title') }}</h4>
              <h5 class="user-cta__subtitle">{{ subtitle }}</h5>
            </div>
            <b-button class="user-cta__action" variant="primary" @click="doLogin" target="_blank">
              {{ $t('sso.btn_login') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  name: 'SingleSignOn',
  components: {Loader},
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    if (this.isAnonymousAccess || this.noAuthMsg)
      await this.doLogin()
    else
      this.loading = false
  },
  computed: {
    ...mapGetters('auth', ['hasAcceptedRequiredPolicies']),
    subtitle() {
      if (!this.$route.query.t) return ''
      const token = this.jwtDecode(this.$route.query.t)
      return this.$t('sso.subtitle', {email: token.payload.email})
    },
    // for IGD anom email
    isAnonymousAccess() {
      return this.$route.query.hasOwnProperty('anon')
    },
    noAuthMsg() {
      return ['true', '1'].includes(this.$route.query.noAuthMsg)
    }
  },
  methods: {
    ...mapActions('auth', [
      'ssoLogin',
      'getCurrentUser',
    ]),
    async doLogin() {
      this.loading = true
      if (this.$route.query.t && this.$route.query.k) {
        this.$store.commit('SET_IS_PREVIEW_CHECKIN', true)
        try {
          const response = await this.ssoLogin({
            token: this.$route.query.t,
            integration_id: this.$route.query.k,
          })
          await this.getCurrentUser()
          if (response.picacode)
            sessionStorage.setItem('picacode', response.picacode)

          // Check if the user has accepted required policies
          if (!this.hasAcceptedRequiredPolicies) {
            await this.$router.push({name: 'terms', params: {next: 'checkins-list'}})
          } else {
            await this.$router.push({name: 'checkins-list'})
          }
        } catch (error) {
          await this.$router.push({name: 'homepage'})
        }
      }
    },
    jwtDecode(t) {
      let token = {};
      token.raw = t;
      token.header = JSON.parse(window.atob(t.split('.')[0]));
      token.payload = JSON.parse(window.atob(t.split('.')[1]));
      return token;
    }
  }
}
</script>
<style>
.site-banner {
  display: none !important;
}
</style>
